//Formatting the number with decimal points and suffix letters
function nFormatter(num: number, digits: number) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });

  if (item) {
    let rounded = (num / item.value).toFixed(digits);
    // Check if rounding pushes it into the next range
    if (parseFloat(rounded) >= 1000 && item.value !== 1) {
      const nextItem = lookup[lookup.indexOf(item) + 1];
      rounded = (num / nextItem.value).toFixed(digits);
      return rounded.replace(rx, '$1') + nextItem.symbol;
    }
    return rounded.replace(rx, '$1') + item.symbol;
  }

  return num < 1 ? num.toFixed(digits).replace(rx, '$1') : '0';
}
//Display the numeric value in a unified string format for the entire system
export function displayNumberFormat(
  number: number,
  currency?: string,
  decimal: number = 2,
): string {
  const sign = Math.sign(number);
  const absNum = Math.abs(number);
  const numStr = nFormatter(absNum, decimal); //format number with letters

  const display = currency ? `${currency}${numStr}` : numStr;

  //add sign
  return sign < 0 ? '-' + display : display;
}

/*
 * Tests
 */
// const tests = [
//   { num: 0, digits: 2 },
//   { num: 12, digits: 2 },
//   { num: -1234, digits: 2 },
//   { num: -100000000, digits: 2 },
//   { num: 299792458, digits: 2 },
//   { num: 759878, digits: 2 },
//   { num: 759878, digits: 2 },
//   { num: 123, digits: 2 },
//   { num: 123.453, digits: 2 },
//   { num: 123.456, digits: 2 },
//   { num: 123020045.456, digits: 2 },
// ];

// tests.forEach(function (test) {
//   console.log('Display (' + test.num + ', ' + test.digits + ') = ' + displayNumberFormat(test.num));
// });
